import { MutableCustomer } from "shared";
import { apiRoutes } from "../../../routing/routes";

export async function saveCustomerInfo(customer: MutableCustomer) {
  const response = await fetch(apiRoutes.customer, {
    headers: {
      "content-type": "application/json",
    },
    method: "PUT",
    body: JSON.stringify(customer),
  });

  if (!response.ok) {
    throw response;
  }
}
